export const decideDesignType = (CAPI) => {
    if (CAPI.designType === 'Immersive')
        return 'Article';
    if (CAPI.designType === 'SpecialReport')
        return 'Article';
    if (CAPI.designType === 'GuardianLabs')
        return 'AdvertisementFeature';
    return CAPI.designType;
};
